import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-965720a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-fanhui" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-gengduo" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import {ref, computed, watch, inject, onMounted, nextTick} from 'vue';
import {useRouter} from 'vue-router';
import TitleBar from '@/components/TitleBar.vue';
import MWebComponent from '@/components/MWebComponent.vue';
import {closeWindow, reportLog} from '@/bridge/index';
import useUa from '@/hooks/useUa';
import useTimeReport from '@/hooks/useTimeReport';
import {useNewsDetail, useContent} from '@/service/detail';
import {haboClickReport} from '@/plugins/haboConfig';
import Article from './Article/index.vue';
import MorePopup from './MorePopup/index.vue';

// 控制 popup

const __default__ = {
  name: 'Detail',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isShowPopup = ref<boolean>(false);
const hidePopup: () => void = () => {
  isShowPopup.value = false;
};

const showPopup: () => void = () => {
  isShowPopup.value = true;
  haboClickReport('INFO_ARTICLE_SHARE_CLICK', {
    news_id: infoId.value,
  });
};

// 控制 title 是否显示资讯 title
const isScrollTop = ref<boolean>(true);
const changeIsTop = (isTop: boolean) => {
  isScrollTop.value = isTop;
};

const router = useRouter();
const infoId = ref<number>(+router.currentRoute.value.params.infoId as number);
const {isApp, outOpenParams, isXApp} = useUa();
const appNameTxt = computed(() => {
  if (isXApp.isGaotuApp) {
    return '高途';
  }
  if (isXApp.isGongkaoApp) {
    return '高途公考';
  }
  if (isXApp.isTutuApp) {
    return '途途课堂';
  }
  if (isXApp.isJingpinApp) {
    return '高中规划';
  }
  if (isXApp.isXinliApp) {
    return '高途心理';
  }
  if (isXApp.isKetangApp) {
    return '高途课堂';
  }
  return '';
});
// 是否显示外部打开组件
const isMWebComponentShow = ref<boolean>(outOpenParams.channel === 'browser');

// 请求文章 detail
const {
  data: detailData,
  isFetching,
  isFinished,
  error: detailErr,
  execute,
} = useNewsDetail(infoId.value);

const htmlString = ref<{
  data: string;
  isFinished: boolean; // 请求完成
  isFetching: boolean; // 正在请求
  error: any;
  isOut: boolean; // 是否下架
}>({
  data: '',
  isFinished: false,
  isFetching: false,
  error: null,
  isOut: false,
});
watch(detailData, async () => {
  if (detailData.value?.code === 0) {
    const {title, url} = detailData.value.data;
    document.title = title as string;

    // 请求 content
    htmlString.value.isFetching = true;
    const {data, isFinished, error} = await useContent(url);
    htmlString.value.data = data.value as string;
    htmlString.value.isFinished = isFinished.value;
    htmlString.value.error = error.value;
    htmlString.value.isFetching = false;
  }
  else if (detailData.value?.code === 1002) {
    // 下架
    htmlString.value.isFinished = true;
    htmlString.value.isOut = true;
  }
  else {
    htmlString.value.isFinished = true;
    htmlString.value.error = true;
  }
  nextTick(() => {
    reportLog('fmp');
  });
});
// 首屏完成 和 首屏错误 和 首屏正在加载
const firstPageFinished = computed(
  () => isFinished && htmlString.value.isFinished,
);
const firstPageError = computed(
  () => !!(detailErr.value || htmlString.value.error),
);
const firstPageFetching = computed(
  () => isFetching.value || htmlString.value.isFetching,
);

const handleRouteByBtn = inject('handleRouteByBtn') as (type: 'forward' | 'backward') => void;
// titleBar 返回
const handleBack = () => {
  handleRouteByBtn('backward');
  if (isApp) {
    closeWindow();
  }
  else {
    router.back();
  }
};
// 获取 url 上的 statusBarHeight  高度
const statusBarHeight = computed(() => {
  const {
    query: {statusBarHeight},
  } = router.currentRoute.value;
  return `${statusBarHeight || 0}px`;
});


onMounted(() => {
  haboClickReport('INFO_PAGE_PREVIEW', {
    news_id: infoId.value,
    stay_time: 0,
    page_source: 'detail',
  });
});

useTimeReport('INFO_ARTICLE_PAGE_STAY_TIME');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "detail-page",
    style: _normalizeStyle({ zIndex: _unref(router).currentRoute.value.name === 'detail' ? 10 : 0 })
  }, [
    (!isMWebComponentShow.value)
      ? (_openBlock(), _createBlock(TitleBar, {
          key: 0,
          title: isScrollTop.value ? _unref(appNameTxt) : _unref(detailData)?.data.title,
          "notice-bar-height": _unref(statusBarHeight)
        }, {
          left: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", {
              class: "icon back-icon",
              "aria-hidden": "true",
              onClick: handleBack
            }, _hoisted_2))
          ]),
          right: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("svg", {
              class: "icon more-icon",
              "aria-hidden": "true",
              onClick: showPopup
            }, _hoisted_4, 512)), [
              [_vShow, 
            _unref(firstPageFinished) &&
              !_unref(firstPageFetching) &&
              !_unref(firstPageError) &&
              !htmlString.value.isOut
          ]
            ])
          ]),
          _: 1
        }, 8, ["title", "notice-bar-height"]))
      : _createCommentVNode("", true),
    (isMWebComponentShow.value)
      ? (_openBlock(), _createBlock(MWebComponent, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(Article, {
      "detail-data": _unref(detailData)?.data!,
      content: htmlString.value.data || '',
      "is-finished": _unref(firstPageFinished),
      error: _unref(firstPageError),
      "first-page-fetching": _unref(firstPageFetching),
      "is-out": htmlString.value.isOut,
      refetch: _unref(execute),
      "change-is-top": changeIsTop
    }, null, 8, ["detail-data", "content", "is-finished", "error", "first-page-fetching", "is-out", "refetch"]),
    _createVNode(MorePopup, {
      "information-id": infoId.value,
      "detail-info": _unref(detailData)?.data!,
      "is-show-popup": isShowPopup.value,
      "hide-popup": hidePopup
    }, null, 8, ["information-id", "detail-info", "is-show-popup"])
  ], 4))
}
}

})